var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.162 15.6c0.20885 0.23617 0.51307 0.35061 0.84001 0.35061 0.29966 0 0.59934-0.11051 0.83543-0.35061l4.6267-4.7448c0.44042-0.46336 0.44042-1.1849-0.022608-1.6479-0.46764-0.44541-1.185-0.44541-1.6481 0.028049l-2.6334 2.7197v-8.441c1e-6 -0.65381-0.50852-1.1614-1.1578-1.1614-0.65381 0-1.1624 0.5088-1.1624 1.1614v8.441l-2.6516-2.6925c-0.44496-0.46785-1.185-0.46785-1.6527-0.028049-0.46312 0.4398-0.46312 1.1849-0.022775 1.6526zm10.838-0.9766v5.8571c0 0.65387-0.51761 1.167-1.1624 1.167h-17.675c-0.64927 2.81e-4 -1.1624-0.51329-1.1624-1.1656v-5.8577c0-0.64966 0.51307-1.1629 1.1624-1.1629 0.65381 0 1.1624 0.51329 1.1624 1.1629v4.6947h15.346v-4.6947c0-0.64966 0.51307-1.1629 1.1669-1.1629 0.64473 0 1.1624 0.51329 1.1624 1.1629",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.5ba1e6e27a027f8cd179ddc8d6148867.svg";
export { ForwardRef as ReactComponent };